export default __webpack_public_path__ + "static/media/Sign.4c3df6e3.png";